;(function () {
  angular.module('contrast.filters').filter('getByKey', function () {
    return function (data, key) {
      if (typeof data === 'undefined' || typeof key === 'undefined') {
        return []
      }

      var result = []
      for (var i = data.length - 1; i >= 0; i--) {
        result.push(data[i][key])
      }

      return result
    }
  })
})()
